import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPublic } from '../api/portfolio';

// Async thunk to post the public data to /public/score endpoint
export const fetchPublicScore = createAsyncThunk(
  'public/fetchPublicScore',
  async ({ email, portfolio }, { rejectWithValue }) => {
    try {
      const data = await fetchPublic({ email, portfolio });
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch public score'
      );
    }
  }
);

const initialState = {
  email: '',
  portfolio: '',
  publicScore: null,
  fetchStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null
};

const publicSlice = createSlice({
  name: 'public',
  initialState,
  reducers: {
    // Store the public email from the hero section
    setEmail(state, action) {
      state.email = action.payload;
    },
    // Store the portfolio input from the hero section
    setPortfolio(state, action) {
      state.portfolio = action.payload;
    },
    // Optional: Clear all public data (if needed)
    clearPublicData(state) {
      state.email = '';
      state.portfolio = '';
      state.publicScore = null;
      state.fetchStatus = 'idle';
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPublicScore.pending, (state) => {
        state.fetchStatus = 'loading';
        state.error = null;
      })
      .addCase(fetchPublicScore.fulfilled, (state, action) => {
        state.fetchStatus = 'succeeded';
        const data = action.payload;

        state.publicScore = typeof data === 'number' ? data : data.score;
      })
      .addCase(fetchPublicScore.rejected, (state, action) => {
        state.fetchStatus = 'failed';
        state.error = action.payload;
      });
  }
});

export const { setEmail, setPortfolio, clearPublicData } = publicSlice.actions;
export default publicSlice.reducer; 